module.exports = __webpack_public_path__ + "static/media/when-i-was-the-prettiest.f23a8a18.md";